import React from "react";
import { Container } from "./Container";

export const Section = ({
  id,
  eyebrow,
  title,
  intro,
  className = "",
  bg = "white",
  children,
  align = "left",
  containerClassName = "",
  testId,
  // Phase 24 polish — eyebrow colour rule: blue for section headers (default),
  // orange only for conversion / partner surfaces, subtle for micro-labels.
  tone = "blue",
}) => {
  const toneClass =
    tone === "orange"
      ? "text-brand-orange"
      : tone === "subtle"
      ? "text-subtle"
      : "text-brand-blue";
  const bgClass =
    bg === "muted"
      ? "bg-muted"
      : bg === "tint"
      ? "bg-brand-orange-tint"
      : "bg-white";
  const headerAlign = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <section
      id={id}
      data-testid={testId}
      className={`${bgClass} py-24 md:py-32 ${className}`}
    >
      <Container className={containerClassName}>
        {(eyebrow || title || intro) && (
          <div className={`max-w-2xl ${headerAlign} mb-14 md:mb-20`}>
            {eyebrow && (
              <div className={`qv-eyebrow mb-4 ${toneClass}`} data-testid={testId ? `${testId}-eyebrow` : undefined}>
                {eyebrow}
              </div>
            )}
            {title && <h2 className="qv-h2">{title}</h2>}
            {intro && <p className="qv-lead mt-5">{intro}</p>}
          </div>
        )}
        {children}
      </Container>
    </section>
  );
};

export default Section;
